import { request } from '@@/plugin-request/request';

/** 登录接口 POST /sys/login */
export async function login(body: {
  username: string;
  password: string;
  captcha: string;
  uuid?: string;
}, options?: { [key: string]: any }) {
  return request<{
    code: number;
    msg: string;
    expire?: number;
    token?: string;
    data?: {
      token: string;
      userInfo: any;
    };
  }>('/sys/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取验证码 GET /captcha.jpg */
export async function getCaptcha(uuid?: string, options?: { [key: string]: any }) {
  const params = uuid ? { uuid } : {};
  return request('/captcha.jpg', {
    method: 'GET',
    responseType: 'blob',
    params,
    ...(options || {}),
  });
}

/** 获取当前用户信息 */
export async function getCurrentUser(options?: { [key: string]: any }) {
  const res = await request<{
    code: number;
    message?: string;
    msg?: string;
    data?: any;
    user?: any;
  }>('/sys/user/info', {
    method: 'GET',
    ...(options || {}),
  });
  // 兼容 user 字段
  if (res && !res.data && res.user) {
    res.data = res.user;
  }
  return res;
}

/** 退出登录 */
export async function logout(options?: { [key: string]: any }) {
  return request<{
    code: number;
    message: string;
  }>('/sys/logout', {
    method: 'POST',
    ...(options || {}),
  });
}
